import React from 'react';
import {BrowserRouter, Routes, Route, Navigate, useLocation} from 'react-router-dom';
import {Header} from "./components/Header";
import {StepOne} from "./pages/StepOne";
import {InputFieldsProvider} from "./contexts/InputFields";
import {StepTwo} from "./pages/StepTwo";
import {PlansProvider} from "./contexts/Plans";
import {Success} from "./pages/Success";
import {FloatingWhatsButton} from "./components/FloatingWhatsButton";


function App() {
    return (
        <InputFieldsProvider>
            <BrowserRouter>
                <PlansProvider>
                    <div
                        className="min-h-screen bg-brand-radial text-base flex flex-col items-center justify-center py-12 text-primary">
                        <Routes>
                            <Route path="/" element={
                                <div
                                    className={"w-1/2 max-w-screen-sm px-2 flex flex-col items-center justify-center gap-6 lg:w-4/5 sm:w-full"}>
                                    <Header text={"Passo 1 de 2"}/>
                                    <StepOne/>
                                    <FloatingWhatsButton />
                                </div>
                            }/>

                            <Route path="/passo-2" element={
                                <div className="px-2 flex flex-col items-center justify-center gap-6 w-11/12 pb-28">
                                    <Header text={"Passo 2 de 2"}/>
                                    <StepTwo/>
                                    <FloatingWhatsButton />
                                </div>
                            }/>

                            <Route path="/sucesso" element={
                                <div
                                    className="w-1/2 max-w-screen-sm px-2 flex flex-col items-center justify-center gap-6 lg:w-4/5 sm:w-full">
                                    <Header text={"Sucesso"}/>
                                    <Success/>
                                </div>
                            }/>

                            {/* Fallback route to redirect to home, preserving any URL parameters */}
                            <Route path="*" element={
                                <Navigate to="/" replace/>
                            }/>
                        </Routes>
                    </div>
                </PlansProvider>
            </BrowserRouter>
        </InputFieldsProvider>
    );
}

export default App;
